/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsMessagePerLocation {
    getFixupPrototypeFunction() { return ProgressDetailsMessagePerLocation.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsMessagePerLocation>): ProgressDetailsMessagePerLocation {
        let obj = Object.assign(new ProgressDetailsMessagePerLocation(), model);
        ProgressDetailsMessagePerLocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsMessagePerLocation>): ProgressDetailsMessagePerLocation {
        if (!model) return null;
        return ProgressDetailsMessagePerLocation.newInstance(<ProgressDetailsMessagePerLocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsMessagePerLocation) {
        if (!obj) return;

        models.ProgressDetailsMessagePerLocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsMessagePerLocation): boolean {
        Object.setPrototypeOf(obj, ProgressDetailsMessagePerLocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.location) {
            models.LocationDetailsBase.fixupPrototype(this.location);
        }
    }

    /**
     * Optional region details
     */
    location: models.LocationDetailsBase;

    /**
     * status message on the sync
     */
    message: string;

}
